import React from 'react';
import Navbar from '../../components/Navbar/Navbar';

const ContactUs = () => {
    return (
        <>
            <Navbar></Navbar>
            <div className="container py-5 my-5">
                <h1>Hello from Contact Us</h1>
            </div>
        </>
    );
};

export default ContactUs;